import type { ComponentProps, ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Button from "@/v2-backoffice-client/components/button"

export type BulkFormActionsProps = ComponentProps<"div"> & {
  onAddRow(): void
  addRowLabel?: string
  onReset?(): void
  resetLabel?: string
  count: number
  countLabel?: string
  hint?: ReactNode
  warning?: ReactNode
}

function BulkFormActions(props: BulkFormActionsProps) {
  const {
    onAddRow,
    addRowLabel = "Add row",
    onReset,
    resetLabel = "Reset",
    count,
    countLabel = "row(s)",
    hint,
    warning,
    className,
    children,
    ...divProps
  } = props

  return (
    <div className={cn("bulk-form-actions", className)} {...divProps}>
      <Button
        type="button"
        variant="outline"
        size="xs"
        iconSrc="plus"
        onClick={onAddRow}
      >
        {addRowLabel}
      </Button>

      {onReset && (
        <Button
          type="button"
          variant="ghost"
          size="xs"
          iconSrc="refresh"
          onClick={onReset}
        >
          {resetLabel}
        </Button>
      )}

      <span className="bulk-form-count">
        {count} {countLabel}
      </span>

      {hint && <span className="bulk-form-actions-hint">{hint}</span>}
      {warning && <span className="bulk-form-warning">{warning}</span>}
      {children}
    </div>
  )
}

export default BulkFormActions
